/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { FieldType } from './FieldType.js';
import {
    FieldTypeFromJSON,
    FieldTypeFromJSONTyped,
    FieldTypeToJSON,
} from './FieldType.js';
import type { SearchResultDisplayType } from './SearchResultDisplayType.js';
import {
    SearchResultDisplayTypeFromJSON,
    SearchResultDisplayTypeFromJSONTyped,
    SearchResultDisplayTypeToJSON,
} from './SearchResultDisplayType.js';

/**
 * 
 * @export
 * @interface UpdateFieldRequest
 */
export interface UpdateFieldRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldRequest
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldRequest
     */
    placeholder?: string;
    /**
     * 
     * @type {FieldType}
     * @memberof UpdateFieldRequest
     */
    type?: FieldType;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldRequest
     */
    options?: string;
    /**
     * 
     * @type {SearchResultDisplayType}
     * @memberof UpdateFieldRequest
     */
    searchResultDisplayType?: SearchResultDisplayType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFieldRequest
     */
    isMultiple?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFieldRequest
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldRequest
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldRequest
     */
    tags?: string;
}

/**
 * Check if a given object implements the UpdateFieldRequest interface.
 */
export function instanceOfUpdateFieldRequest(value: object): boolean {
    return true;
}

export function UpdateFieldRequestFromJSON(json: any): UpdateFieldRequest {
    return UpdateFieldRequestFromJSONTyped(json, false);
}

export function UpdateFieldRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFieldRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'] == null ? undefined : json['slug'],
        'name': json['name'] == null ? undefined : json['name'],
        'placeholder': json['placeholder'] == null ? undefined : json['placeholder'],
        'type': json['type'] == null ? undefined : FieldTypeFromJSON(json['type']),
        'options': json['options'] == null ? undefined : json['options'],
        'searchResultDisplayType': json['searchResultDisplayType'] == null ? undefined : SearchResultDisplayTypeFromJSON(json['searchResultDisplayType']),
        'isMultiple': json['isMultiple'] == null ? undefined : json['isMultiple'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'order': json['order'] == null ? undefined : json['order'],
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}

export function UpdateFieldRequestToJSON(value?: UpdateFieldRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'slug': value['slug'],
        'name': value['name'],
        'placeholder': value['placeholder'],
        'type': FieldTypeToJSON(value['type']),
        'options': value['options'],
        'searchResultDisplayType': SearchResultDisplayTypeToJSON(value['searchResultDisplayType']),
        'isMultiple': value['isMultiple'],
        'isEnabled': value['isEnabled'],
        'order': value['order'],
        'tags': value['tags'],
    };
}

